import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Separator } from "@/components/ui/separator";
import { Card } from "@/components/ui/card";
import { WorkflowControl } from "@/components/WorkflowControl";
import { TaskList } from "@/components/TaskList";
import { ApiKeyManager } from "@/components/security/ApiKeyManager";
import { DashboardTabs } from "@/components/dashboard/DashboardTabs";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const Index = () => {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-background flex flex-col">
        <main className="container py-8 flex-1">
          <ErrorBoundary>
            <div className="mb-8">
              <h1 className="text-3xl font-bold tracking-tight">Workflow Dashboard</h1>
              <p className="text-muted-foreground mt-2">
                Monitor and manage your autonomous workflow
              </p>
            </div>

            <div className="space-y-8">
              {/* Workflow Control Section */}
              <Card className="p-6 bg-gradient-to-r from-primary/10 via-primary/5 to-transparent border-none">
                <WorkflowControl />
              </Card>
              
              <div className="space-y-4">
                <h2 className="text-xl font-semibold">Current Tasks</h2>
                <Card className="p-6">
                  <TaskList tasks={[]} isLoading={false} />
                </Card>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <h2 className="text-xl font-semibold">API Key Management</h2>
                  <Card className="p-6">
                    <ApiKeyManager />
                  </Card>
                </div>
              </div>

              <Separator className="my-8" />
              
              <DashboardTabs />
            </div>
          </ErrorBoundary>
        </main>
      </div>
    </ErrorBoundary>
  );
};

export default Index;